const ACCESS_MODE_KEY = 'nexo_access_mode';
const ACCESS_MODE_ADMIN = 'admin';
const ACCESS_MODE_CAJERO = 'cajero';

export const isAdminLikeRole = (user) => {
  const rol = String(user?.rol || user?.role || '').toLowerCase();
  const rolId = String(user?.rolId || user?.roleId || '').toLowerCase();
  return (
    rol.includes('admin') ||
    rol.includes('super') ||
    rolId.includes('admin') ||
    user?.isAdmin === true
  );
};

/**
 * ¿Puede abrir el panel admin (web)?
 * Solo el cajero puro queda restringido al mostrador.
 * Empleado/gerente/admin entran al panel; los permisos efectivos limitan módulos.
 */
export const canAccessAdminPanel = (user) => {
  if (!user) return false;
  if (isAdminLikeRole(user)) return true;
  const rolId = String(
    user?.rolId || user?.roleId || user?.customClaims?.rolId || user?.customClaims?.role || ''
  ).toLowerCase();
  const rol = String(user?.rol || user?.role || user?.customClaims?.rol || '').toLowerCase();
  if (rolId === 'cajero' || rol === 'cajero') return false;
  if (rolId === 'empleado' || rol.includes('empleado')) return true;
  if (rolId === 'gerente' || rol.includes('gerente') || rol.includes('manager')) return true;
  // Rol hidratado distinto de cajero/vacío
  if (rolId && rolId !== '1' && rolId !== 'usuario') return true;
  if (rol && rol !== 'usuario' && !rol.includes('cajero')) return true;
  return false;
};

export const normalizeAccessMode = (raw, fallback = ACCESS_MODE_ADMIN) => {
  const normalized = String(raw || '').trim().toLowerCase();
  if (normalized === ACCESS_MODE_ADMIN || normalized === ACCESS_MODE_CAJERO) {
    return normalized;
  }
  return fallback;
};

export const getStoredAccessMode = (fallback = ACCESS_MODE_ADMIN) => {
  try {
    const saved = localStorage.getItem(ACCESS_MODE_KEY);
    return normalizeAccessMode(saved, fallback);
  } catch {
    return fallback;
  }
};

export const setStoredAccessMode = (mode) => {
  const normalized = normalizeAccessMode(mode, ACCESS_MODE_CAJERO);
  try {
    localStorage.setItem(ACCESS_MODE_KEY, normalized);
  } catch {
    // storage no disponible
  }
  return normalized;
};

export const ACCESS_MODES = {
  ADMIN: ACCESS_MODE_ADMIN,
  CAJERO: ACCESS_MODE_CAJERO
};
